import { firebaseDb, firebaseFuncs } from './firebase'
import { GiftBundle, GiftBundleCard, giftBundleConverter } from '../models/GiftBundle'
import { Collection, Functions } from '../config/enums'
import { Gift, giftConverter } from '../models/Gift'


export const getGiftBundles = async (
  vendorId: string
): Promise<GiftBundle[]> => {
  let giftBundles: GiftBundle[] = []
  //giftBundles.push({ name: '', id: '', vendorId: '' })

  try {
    const snapshot = await firebaseDb
      .collection(Collection.giftBundles)
      .orderBy('name', 'asc')
      .where('vendorId', '==', vendorId)
      .withConverter(giftBundleConverter)
      .get()

    snapshot.forEach((doc) => {
      giftBundles.push(doc.data())
    })
  } catch (error) {
    console.log(error)
  }

  return giftBundles
}

export const getGifts = async (giftBundleId: string): Promise<Gift[]> => {
  let gifts: Gift[] = []

  try {
    const snapshot = await firebaseDb
      .collection(Collection.gifts)
      .orderBy('name', 'asc')
      .where('giftBundleIds', 'array-contains', giftBundleId)
      .withConverter(giftConverter)
      .get()

    snapshot.forEach((doc) => {
      gifts.push(doc.data())
    })
  } catch (error) {
    console.log(error)
  }

  return gifts
}

export const getGift = async (giftId: string): Promise<Gift> => {
  const gift = await firebaseDb
    .collection(Collection.gifts)
    .doc(giftId).get()

  return gift.data() as Gift
}


export const getGiftBundle = async (giftBundleId: string): Promise<GiftBundle> => {
  const giftBundle = await firebaseDb
    .collection(Collection.giftBundles)
    .doc(giftBundleId).get()

  return giftBundle.data() as GiftBundle
}



export const getVendorGifts = async (vendorId: string): Promise<Gift[]> => {
  let gifts: Gift[] = []

  try {
    const snapshot = await firebaseDb
      .collection(Collection.gifts)
      .orderBy('name', 'asc')
      .where('vendorId', '==', vendorId)
      .withConverter(giftConverter)
      .get()

    snapshot.forEach((doc) => {
      gifts.push(doc.data())
    })
  } catch (error) {
    console.log(error)
  }

  return gifts
}

export const getBundledGifts = async (vendorId: string): Promise<GiftBundleCard[]> => {

  const vendorGifts = await getVendorGifts(vendorId!)
  const giftBundles = await getGiftBundles(vendorId!)
  const formattedGiftBundleArray: GiftBundleCard[] = []

  giftBundles.forEach((giftBundle: GiftBundle) => {
    const gifts = vendorGifts.filter(gift => {
      return gift.giftBundleIds?.includes(giftBundle.id)
    })
    formattedGiftBundleArray.push({ id: giftBundle.id, name: giftBundle.name, gifts: gifts })
  })

  return formattedGiftBundleArray
}

export const getUnbundledGifts = async (vendorId: string) => {
  const vendorGifts = await getVendorGifts(vendorId!)
  const formattedGiftArray: Gift[] = []

  vendorGifts.forEach((gift: Gift) => {

    if (gift.giftBundleIds?.length === 0) {
      formattedGiftArray.push(gift)
    }
  })

  return formattedGiftArray
}

export const createGift = async (name: string, isActive: boolean, giftBundleIds: string[], imageUrl: string): Promise<String | null> => {
  const createGiftFunc = firebaseFuncs.httpsCallable(Functions.createGift)

  let params: any = { name: name, isActive: isActive, giftBundleIds: giftBundleIds, imageUrl: imageUrl }

  try {
    const res = await createGiftFunc(params)

    if (res.data) {
      return res.data.giftId
    } else {
      return null
    }
  } catch (error) {
    console.error(error)
    return null
  }

}

export const createGiftBundle = async (name: string): Promise<String | null> => {
  const createGiftBundleFunc = firebaseFuncs.httpsCallable(Functions.createGiftBundle)

  let params: any = { name: name }
  const res = await createGiftBundleFunc(params)

  if (res.data) {
    return res.data.id
  } else {
    return null
  }

}

export const updateGift = async (id: string, name?: string, isActive?: boolean, giftBundleIds?: string[], imageUrl?: string): Promise<String | null> => {
  const updateGiftFunc = firebaseFuncs.httpsCallable(Functions.updateGift)

  let params: any = { id: id }

  if (name) {
    params.name = name
  }

  if (isActive !== undefined) {
    params.isActive = isActive
  }

  if (giftBundleIds) {
    params.giftBundleIds = giftBundleIds
  }

  if (imageUrl) {
    params.imageUrl = imageUrl
  }
  console.log(params)
  try {
    const res = await updateGiftFunc(params)

    if (res.data) {
      return res.data.success
    } else {
      return null
    }
  } catch (error) {
    console.error(error)
    return null
  }

}

export const updateGiftBundle = async (id: string, name: string): Promise<String | null> => {
  const updateGiftBundleFunc = firebaseFuncs.httpsCallable(Functions.updateGiftBundle)

  let params: any = { id: id, name: name }
  const res = await updateGiftBundleFunc(params)

  if (res.data) {
    return res.data.success
  } else {
    return null
  }

}

export const deleteGift = async (id: string): Promise<String | null> => {
  const deleteGiftFunc = firebaseFuncs.httpsCallable(Functions.deleteGift)

  try {
    const res = await deleteGiftFunc({ id: id })
    if (res.data) {
      return res.data.success
    } else {
      return null
    }
  } catch (error) {
    console.error(error)
    return null
  }

}

export const deleteGiftBundle = async (id: string): Promise<String | null> => {
  const updateGiftBundleFunc = firebaseFuncs.httpsCallable(Functions.deleteGiftBundle)

  let params: any = { id: id }
  const res = await updateGiftBundleFunc(params)

  if (res.data) {
    return res.data.success
  } else {
    return null
  }

}